export default __webpack_public_path__ + "static/media/news-sc.00d91708.jpg";